export const UserTypes = {
    CUSTOMER: 'customer',
    CHEF: 'chef'
};